import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import styles from './page-header.module.css';

type PageHeaderProps = {
  header: string;
  subheader?: string;
  rightExtra?: ReactNode;
};

export const PageHeader = observer(
  ({ header, subheader, rightExtra = null }: PageHeaderProps) => {
    return (
      <div className={styles.container}>
        <div>
          <h1 className={styles.header}>{header}</h1>
          {subheader && <span className={styles.subheader}>{subheader}</span>}
        </div>
        {rightExtra}
      </div>
    );
  }
);
